import { render, staticRenderFns } from "./PhoneCalls.vue?vue&type=template&id=4ca7d342"
import script from "./PhoneCalls.vue?vue&type=script&lang=js"
export * from "./PhoneCalls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports